var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',{attrs:{"datetime":_vm.utcTimeString,"title":_vm.utcTimeString}},[_vm._v(_vm._s(_vm._f("utcToLocal")(_vm.time,_vm.format)))])
}
var staticRenderFns = []

export { render, staticRenderFns }